import React from 'react'
import { logger } from '../../shared/utils/logger'

type Props = { children: React.ReactNode }

type State = { hasError: boolean; error?: unknown }

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: unknown) {
    return { hasError: true, error }
  }

  componentDidCatch(error: unknown, errorInfo: any) {
    logger.error('UI ErrorBoundary', error, errorInfo)
    console.error('🚨 ErrorBoundary caught error:', error)
    console.error('🚨 ErrorBoundary error info:', errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 16 }}>
          <h2>Произошла ошибка</h2>
          <p>Попробуйте обновить страницу или вернуться позже.</p>
        </div>
      )
    }
    return this.props.children
  }
}
